import RightAnimationTitle from '../RightAnimationTitle';
import { LinkButton } from '../../modules';

const Offer = () => {
  type OfferItem = {
    title: string;
    body: string;
  };

  const offerItems: OfferItem[] = [
    {
      title: 'WebサイトとSNSの連携を無料サポート',
      body: '今の時代、ビジネスにSNSは欠かせません。本来はオプション料金となる「Instagramフィードの埋め込み」や、LINE等でシェアした際の見栄えを良くする「OGP設定」を完全無料でサポートします。',
    },
    {
      title: '地元のビジネスをデザインで応援',
      body: '「どうやって集客すればいいかわからない」「名刺やロゴも欲しい」といったお悩みもご相談ください。浦安・市川エリアの新規開業者様を、プロの目線とデザインの力で徹底的にお手伝いします。',
    },
  ];

  return (
    <div className="container background-white container-shadow">
      <div className="budoul"></div>
      <h1 className="container_title container_right">Offer</h1>
      <RightAnimationTitle
        text="市川・浦安で新規開業される方向けの特別オファー"
        id="offerAnimation"
        x1={1000}
        x2={0}
      ></RightAnimationTitle>
      <section className="flow container-l homeSection" style={{ paddingBottom: '60px' }}>
        {offerItems.map((value, index) => {
          return (
            <div className="flow_box" key={index.toString()}>
              <h2 className="flow_box_title">
                <span style={{ marginRight: '10px' }}>✓</span>
                {value.title}
              </h2>
              <p className="flow_box_body" style={{ marginTop: '10px', lineHeight: '1.8' }}>{value.body}</p>
            </div>
          );
        })}
        
        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <LinkButton to="/campaign" text="キャンペーンの詳細を見る" />
        </div>
      </section>
    </div>
  );
};

export default Offer;
